import { Card, CardContent, Stack, TextField, Typography } from '@mui/material'
import { StowageInstructionResponseDto } from '@storage/app/api'
import { useTranslate } from '@tolgee/react'
import { useMinimalsTheme } from '@tom-ui/ui'
import { FormField, IFormStore } from '@tom-ui/utils'
import { observer } from 'mobx-react-lite'
import { IStowageInstructionFormData } from '../../models/stowage-instruction.model'

interface Props {
  formStore: IFormStore<IStowageInstructionFormData>
  stowageInstruction: StowageInstructionResponseDto | undefined
  stowageInstructionNames: string[]
}

export const StowageInstructionForm = observer(
  ({ formStore, stowageInstruction, stowageInstructionNames }: Props) => {
    const { t } = useTranslate()
    const theme = useMinimalsTheme()

    return (
      <Card>
        <CardContent>
          <Stack component='form' noValidate autoComplete='off' gap={theme.customSpacing.l}>
            <Stack flexDirection='row' justifyContent='space-between' alignItems='center'>
              <Typography variant='subtitle1'>
                {t('stowageInstructionDetails', 'Stowage Instruction details')}
              </Typography>
            </Stack>

            <FormField
              formStore={formStore}
              name={'name'}
              initialValue={stowageInstruction?.name ?? ''}
              validate={value => {
                if (!value) return t('fieldIsRequired', 'Field is required')
                else if (
                  stowageInstructionNames
                    .map(x => x.toLowerCase().trim())
                    .includes(value.toLowerCase().trim())
                ) {
                  return t(
                    'stowageInstructionNameAlreadyExists',
                    'Stowage instruction name already exists',
                  )
                }
              }}
            >
              {store => (
                <Stack gap={theme.customSpacing.s}>
                  <TextField
                    {...store.props}
                    fullWidth
                    label={`${t('name', 'Name')}`}
                    required
                    variant='outlined'
                    type='text'
                    name='name'
                  />
                  <Typography variant='caption' color={store.error ? 'error' : 'text.secondary'}>
                    {store.error
                      ? store.error
                      : t(
                          'pleaseMakeSureItsAUniqueField',
                          "Please make sure it's a unique {field}",
                          {
                            field: t('name', 'name'),
                          },
                        )}
                  </Typography>
                </Stack>
              )}
            </FormField>

            <FormField
              formStore={formStore}
              name={'description'}
              initialValue={stowageInstruction?.description ?? ''}
            >
              {store => (
                <Stack>
                  <TextField
                    {...store.props}
                    fullWidth
                    label={`${t('description', 'Description')}`}
                    variant='outlined'
                    type='text'
                    name='description'
                  />
                </Stack>
              )}
            </FormField>
          </Stack>
        </CardContent>
      </Card>
    )
  },
)
